import { SUBFIELD_TYPES } from '../BytesField';

const MixedMaterialCharsFieldConfig = [
  {
    name: 'Form',
    hint: 'Form of item',
    type: SUBFIELD_TYPES.BYTE,
  },
];

export default MixedMaterialCharsFieldConfig;
